const footerConsentmanagerTrigger = () =>{
    if (window.hasOwnProperty('__cmp') && typeof __cmp !== 'undefined') {
        document.addEventListener('click', ev =>{
            if(!ev.target.closest('.kruse-cookie-trigger')) return;
            __cmp('showScreenAdvanced');
        })
    }
}
export default footerConsentmanagerTrigger;